<template>
  <div class="empty-cart">
    <p class="empty-cart__text">{{ $t('empty') }}</p>
    <a
      :href="`${homepageUrl}${FILTER_PAGE_PATH}`"
      class="empty-cart__btn"
      @click="handleEmptyCartLinkClick(`${FILTER_PAGE_PATH}`)"
      >{{ $t('shop_all') }}
    </a>
    <a
      :href="`${homepageUrl}${FILTER_PAGE_MENS_PATH}`"
      class="empty-cart__btn"
      @click="handleEmptyCartLinkClick(FILTER_PAGE_MENS_PATH)"
      >{{ $t('shop_mens') }}
    </a>
    <a
      :href="`${homepageUrl}${FILTER_PAGE_WOMENS_PATH}`"
      class="empty-cart__btn"
      @click="handleEmptyCartLinkClick(FILTER_PAGE_WOMENS_PATH)"
      >{{ $t('shop_womens') }}
    </a>
    <a
      :href="`${homepageUrl}${SHOE_FINDER_PATH}`"
      class="empty-cart__btn"
      @click="handleEmptyCartLinkClick(SHOE_FINDER_PATH)"
    >
      <span class="icon-shoe-finder"></span>
      {{ $t('shop_shoefinder') }}
    </a>
  </div>
</template>

<script>
import {
  notifyExternalServices,
  ACTIONS,
} from '@/services/external-communication/external-communication'
import {
  FILTER_PAGE_PATH,
  FILTER_PAGE_MENS_PATH,
  FILTER_PAGE_WOMENS_PATH,
  SHOE_FINDER_PATH,
} from '@/config/constants'

export default {
  name: 'EmptyCart',

  props: {
    homepageUrl: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      FILTER_PAGE_PATH,
      FILTER_PAGE_MENS_PATH,
      FILTER_PAGE_WOMENS_PATH,
      SHOE_FINDER_PATH,
    }
  },

  methods: {
    handleEmptyCartLinkClick(href) {
      this.$store.dispatch('nav/setAdditionalNav', '')
      notifyExternalServices({
        action: ACTIONS.navigation,
        details: { action: 'minicart_navigation', label: href },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.empty-cart {
  &__text {
    display: block;
    margin: 14px 0 28px;

    @media ($mq-larger) {
      margin: 10px 0 44px;
    }
  }

  &__btn {
    display: block;
    margin-top: 16px;
    padding: 22px 0 20px;
    text-align: center;
    color: $color-grey-dark-2;
    background-color: $color-grey-light-4;
    transition: background-color $transition-time;

    @media ($mq-larger) {
      margin-top: 26px;
    }

    .icon-shoe-finder {
      position: relative;
      top: -1px;
      font-size: $font-size-large;

      &:before {
        color: $color-grey-dark-2;
      }
    }

    &:hover {
      background-color: $color-grey-light-1;
    }
  }
}
</style>

<i18n src="@/locales/empty_cart.json">
</i18n>
